import { render, staticRenderFns } from "./programEvent.vue?vue&type=template&id=462f5a26&scoped=true&"
import script from "./programEvent.vue?vue&type=script&lang=js&"
export * from "./programEvent.vue?vue&type=script&lang=js&"
import style0 from "./programEvent.vue?vue&type=style&index=0&id=462f5a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f5a26",
  null
  
)

export default component.exports